<template>
    <div class="topcode-wechat-taskSafe-item" @click="$router.push('/safety/task/' + taskSafe.state+'/'+taskSafe.id)">
        <span :class="'sign sign-'+taskSafe.state">{{$DICT.getValue('SAFETY_TASK_STATE', taskSafe.state)}}</span>
        <!--<div class="top">-->
        <!--<div :class="'flex-center-y auto-width-8 state  taskSafe-state-'+taskSafe.state">{{taskSafeStateDICT}}</div>-->
        <!--<div class="flex-center-y time ">{{time}}</div>-->
        <!--</div>-->
        <div class="body">
            <div class="content">
                <div class="flex-center-y center">
                    <img src="./images/order.png"/>
                    <div class="name" style="font-size: 14px">
                        <div class="title">{{taskSafe.name}}</div>
                        <div style="color: #7e7e7e">{{time}}</div>
                    </div>
                </div>
                <div class="flex-center right" style="margin-top: 30px;margin-right: 5px">
                    详情
                    <van-icon name="arrow"/>
                </div>
            </div>
            <div class="footer">
                <div>
                    <div>总数</div>
                    <div>{{ taskSafe.total||0}}</div>
                </div>
                <div style=" color: #1890ff;">
                    <div>未处理</div>
                    <div>{{ taskSafe.unHandleTotal||0 }}</div>
                </div>
                <div style="color: #f5222d;">
                    <div>异常</div>
                    <div>{{ taskSafe.errorTotal||0 }}</div>
                </div>
                <div style="color: #51c332">
                    <div>正常</div>
                    <div>{{ taskSafe.normalTotal ||0}}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import * as DICT from "@/utils/dict"
    import moment from "moment"


    export default {
        components: {},
        props: {
            taskSafe: {type: Object, required: true}
        },
        data() {
            return {};
        },
        computed: {
            time() {
                const {startTime, finishTime} = this.taskSafe
                return `${moment(startTime).format('YYYY-MM-DD')} 至 ${moment(finishTime).format('YYYY-MM-DD')} `
            }
        },
        created() {
        },
        mounted() {
        },
        methods: {},
        watch: {}
    };
</script>

<style lang="less" scoped>

    .sign {
        &.sign-FINISH {
            background: #fa7d2d;
        }
        &.sign-UN_FINISH {
            background: #0dbe4a;
        }
        font-family: 微软雅黑;
        text-decoration: none;
        display: block;
        position: absolute;
        right: -100px;
        width: 150px;
        height: 25px;
        font-size: 10px;
        /*background-color: red;*/
        color: #fff;
        font-weight: bold;
        line-height: 28px;
        text-align: center;
        transform: translate(-33%, 20%) rotate(40deg);
        box-shadow: 0 0 5px rgba(0, 0, 0, 0.5), inset 0 0 2px #fff;
        text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.1);
    }

    .topcode-wechat-taskSafe-item {
        position: relative;
        width: 100%;
        /*height: 225px;*/
        margin-bottom: 8px;
        border-radius: 8px;
        border: 1px #cccccc solid;
        /*background: #51c332;*/
        overflow: hidden;

        & > .top {
            color: #fff;
            display: flex;
            height: 28px;
            border-radius: 8px 8px 0px 0px;
            background: #7e7e7e;
            & > .state {
                height: 100%;
                /*width: 60px;*/
                border-radius: 8px 0px 0px 0px;
            }
            & > .time {
                height: 100%;
                width: 100%;
                padding-right: 5px;
                justify-content: flex-end;

            }
        }
        & > .body {
            display: flex;
            flex-direction: column;
            & > .content {
                /*padding: 8px;*/
                width: calc(100% - 10px);
                display: flex;
                & > .center {
                    padding: 5px;
                    display: flex;
                    width: 100%;
                    /*background: #5cd8bc;*/
                    & > img {
                        width: 50px;
                        height: 50px;
                        /*background: #cccccc;*/
                        border-radius: 8px;
                    }
                    & > .name {
                        padding-left: 20px;
                        height: 100%;
                        display: flex;
                        justify-content: center;
                        /*background: #7e7e7e;*/
                        flex-direction: column;

                        & > div {
                            line-height: 1.5;

                        }
                    }
                }
                & > .right {
                    justify-content: flex-end;
                    width: 70px;
                    color: #fa7d2d;
                    font-size: 14px;
                    font-weight: 500;
                }
                & > .row {
                    display: flex;
                    line-height: 1.5;
                    /*align-items: center;*/
                    & > label {
                        width: 105px;
                        flex-shrink: 0;
                        &::after {
                            margin-left: 2px;
                            content: '：';
                        }
                    }
                    & > span {
                    }
                }
            }
            & > .footer {
                /*border-top: 1px solid #bbb;*/
                width: 100%;
                height: 40px;
                display: flex;
                align-items: center;
                justify-content: space-around;
                text-align: center;
            }
        }
    }
</style>
